import ArticleListPage    from '@/domains/blog/components/ArticleListPage';
import {paginateArticles} from '@/domains/blog/components/Pagination';
import articles           from '@/domains/blog/databases/articles.json';
import authors            from '@/domains/blog/databases/authors.json';
import categories         from '@/domains/blog/databases/categories.json';
import Blur               from '@/domains/marketing/components/Backgrounds/Blur';
import {Container}        from '@/domains/marketing/components/Container';
import PrimaryLayout      from '@/domains/marketing/layouts/PrimaryLayout';
import {useSearchParams}  from 'next/navigation';

export default function Blog() {
	const searchParams = useSearchParams();

	const page = searchParams.get('page') ?? 1;

	const paginatedArticles = paginateArticles([
		...articles,
	]
		.reverse(), page);

	return (<PrimaryLayout pageTitle="The Atlas Software Blog"
	                       description="A list of articles from Atlas Software about developing software using Laravel."
	>
		<Blur className="py-12">
			<Container className="isolate relative">
				<ArticleListPage authors={authors}
				                 categories={categories}
				                 currentCategorySlug={null}
				                 {...paginatedArticles}
				                 hrefForPage={(page) => {
					                 if (page <= 1) {
						                 return `/blog`;
					                 } else {
						                 return `/blog?page=${page}`;
					                 }
				                 }}
				/>
			</Container>
		</Blur>
	</PrimaryLayout>);
}
